import React from "react";

export default function SmartButton({ label, value, icon: Icon, onClick }) {
  return (
    <button 
      onClick={onClick}
      className="flex items-center justify-between bg-white border border-gray-300 h-[40px] min-w-[120px] px-1 hover:bg-gray-50 transition-all duration-200 first:rounded-l-md last:rounded-r-md -ml-px first:ml-0 group"
    >
      <div className="flex items-center gap-2 w-full px-2">
          {/* Icon Section */}
          <div className="text-purple-700 opacity-80 group-hover:opacity-100 transition-opacity">
              <Icon className="w-5 h-5" />
          </div>
          
          {/* Text Section */}
          <div className="flex flex-col items-start leading-tight">
              <span className="text-sm font-bold text-gray-800">{value}</span>
              <span className="text-[10px] text-gray-500 tracking-wide">{label}</span>
          </div>
      </div>
    </button>
  );
}